import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { HeadingColor, HeadingType } from '@freelancer/ui/heading';
import { HoverColor, IconColor, IconSize } from '@freelancer/ui/icon';
import { InputType } from '@freelancer/ui/input';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-hire-me-deloitte-billing-details',
  template: `
    <fl-hr [flMarginBottom]="Margin.SMALL"></fl-hr>
    <fl-bit class="BillingDetailsHeadingWrapper">
      <fl-heading
        i18n="Billing Details Title"
        [color]="HeadingColor.LIGHT"
        [headingType]="HeadingType.H3"
        [size]="TextSize.SMALL"
        [flMarginBottom]="Margin.XSMALL"
      >
        Billing Details
      </fl-heading>
      <fl-button
        flTrackingLabel="expandProjectDetails"
        (click)="handleExpand()"
      >
        <fl-icon
          *ngIf="expanded"
          [color]="IconColor.LIGHT"
          [size]="IconSize.SMALL"
          [hoverColor]="HoverColor.PRIMARY"
          name="ui-chevron-down"
          i18n-label="Billing details collapse icon"
          label="Collapse"
        ></fl-icon>
        <fl-icon
          *ngIf="!expanded"
          [color]="IconColor.LIGHT"
          [size]="IconSize.SMALL"
          [hoverColor]="HoverColor.PRIMARY"
          name="ui-chevron-right"
          i18n-label="Billing details expand icon"
          label="Expand"
        ></fl-icon>
      </fl-button>
    </fl-bit>
    <fl-bit
      *ngIf="expanded"
      [ngClass]="{ ResponsiveContainer: isResponsive }"
      [flMarginBottom]="Margin.XSMALL"
    >
      <fl-bit class="ResponsiveField">
        <fl-text
          i18n="Hire Me project billing code label"
          [weight]="FontWeight.BOLD"
          [color]="FontColor.LIGHT"
        >
          Billing code
        </fl-text>
        <fl-input
          i18n-placeholder="Project Billing Code"
          flTrackingLabel="project billing code"
          placeholder="e.g: ABC00123-AB-01-01-0000"
          [flMarginBottom]="Margin.XSMALL"
          [control]="hireMeFormGroup.get('billingCode')"
        ></fl-input>
      </fl-bit>
      <fl-bit class="ResponsiveField">
        <fl-text
          i18n="Hire Me project billable hours label"
          [weight]="FontWeight.BOLD"
          [color]="FontColor.LIGHT"
        >
          Expected Billable Hours
        </fl-text>
        <fl-input
          i18n-afterLabel="Hrs label"
          afterLabel="Hrs"
          flTrackingLabel="PostProjectBillableHours"
          [control]="hireMeFormGroup.get('billableHours')"
          [flMarginBottom]="Margin.XSMALL"
        ></fl-input>
      </fl-bit>
      <fl-bit class="ResponsiveField">
        <fl-text
          i18n="Hire Me project start date label"
          [weight]="FontWeight.BOLD"
          [color]="FontColor.LIGHT"
        >
          Project start date
        </fl-text>
        <fl-input
          flTrackingLabel="PostProjectTimeFrameStartDate"
          [control]="hireMeFormGroup.get('startDate')"
          [flMarginBottom]="Margin.XSMALL"
          [type]="InputType.DATE"
        ></fl-input>
      </fl-bit>
      <fl-bit class="ResponsiveField">
        <fl-text
          i18n="Hire Me project end date label"
          [weight]="FontWeight.BOLD"
          [color]="FontColor.LIGHT"
        >
          Project end date
        </fl-text>
        <fl-input
          flTrackingLabel="PostProjectTimeFrameCompletionDate"
          [control]="hireMeFormGroup.get('completionDate')"
          [flMarginBottom]="Margin.MID"
          [type]="InputType.DATE"
        ></fl-input>
      </fl-bit>
    </fl-bit>
  `,
  styleUrls: ['./hire-me-deloitte-billing-details.component.scss'],
})
export class HireMeDeloitteBillingDetailsComponent {
  TextSize = TextSize;
  HeadingType = HeadingType;
  HeadingColor = HeadingColor;
  FontColor = FontColor;
  FontWeight = FontWeight;
  InputType = InputType;
  Margin = Margin;
  IconColor = IconColor;
  IconSize = IconSize;
  HoverColor = HoverColor;

  expanded = true;

  @Input() isResponsive = false;
  @Input() hireMeFormGroup: FormGroup;

  handleExpand() {
    this.expanded = !this.expanded;
  }
}
